module.exports = __webpack_public_path__ + "img/bd.6bc03e5a.svg";